export default "__VITE_ASSET__BS6Ag33o__"